// extracted by mini-css-extract-plugin
module.exports = {"root":"YouTube_root__D9ov2","playBtn":"YouTube_playBtn__TQhuw","videoImg":"YouTube_videoImg__yuW14","video":"YouTube_video__OuJX4"};